import React from 'react';
import { PAGE_MODE } from '../../../constants/pageModeTypes';
import CheckedXIcon from '@shared/components/CheckedXIcon';
import { Checkbox } from '@mui/material';

const FDA_ATM_CHECKBOX_LABEL = 'FDA ATM';
const INTERNAL_ATM_CHECKBOX_LABEL = 'Internal ATM';
const STAFF_ATM_CHECKBOX_LABEL = 'Staff ATM';

const PAGE_MODE_CHECKBOX_LABEL = {
  [PAGE_MODE.ISACAVipOrg]: STAFF_ATM_CHECKBOX_LABEL,

  [PAGE_MODE.FDAVipOrg]: FDA_ATM_CHECKBOX_LABEL,

  [PAGE_MODE.MddapOrg]: INTERNAL_ATM_CHECKBOX_LABEL,
  [PAGE_MODE.OrgUnit]: INTERNAL_ATM_CHECKBOX_LABEL
};

/**
 * @typedef {object} AtmCheckboxProps
 * @property {number} pageMode
 * @property {boolean} isAtm
 * @property {(checked: boolean) => void} setIsAtm
 * @property {boolean} [disabled]
 */

/**
 * @param {AtmCheckboxProps} props
 */
export const AtmCheckbox = props => {
  const { pageMode, isAtm, setIsAtm, disabled = false } = props;

  return (
    <div className='checkbox-wrapper' data-testid='atm-checkbox-wrapper'>
      <h4 className='field-title'>{PAGE_MODE_CHECKBOX_LABEL[pageMode]}</h4>
      <Checkbox
        size='small'
        checked={isAtm}
        checkedIcon={<CheckedXIcon size='small' />}
        onChange={e => setIsAtm(e.target.checked)}
        color='default'
        disabled={disabled}
      />
    </div>
  );
};

export default AtmCheckbox;
